export default __webpack_public_path__ + "static/media/144.eabd3e07.png";